import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const content = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '8rem',
});

const title = style({
  display: 'flex',
  gap: themeVars.spacing.md,
  alignItems: 'center',
  marginBottom: themeVars.spacing.lg,
});

const bulletList = style({
  margin: `${themeVars.spacing.md} 0`,
  paddingLeft: themeVars.spacing.md,
});

const bullet = style({
  listStyleType: 'disc',
});

const bulletAdjacent = style({
  marginTop: '1.2rem',
});

const containerCard = style({
  marginBottom: themeVars.spacing.lg,
});

const icon = style({
  color: themeVars.color.semantic.text.neutral20,
});

const link = style({
  marginTop: '2rem',
});

export const css = {
  content,
  title,
  bulletList,
  bulletAdjacent,
  containerCard,
  icon,
  link,
  bullet,
};
